var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.04 21.12C21.04 21.12 24.8534 17.3333 26.1467 16C30.24 12 28.2 3.76 28.2 3.76C28.2 3.76 20 1.72 16 5.81333C12.88 8.85333 10.8534 10.96 10.8534 10.96C10.8534 10.96 5.73335 9.89333 2.66669 12.96L19 29.3333C22.0667 26.2267 21.04 21.12 21.04 21.12ZM19.04 9.12C19.2877 8.87206 19.5818 8.67537 19.9055 8.54117C20.2292 8.40698 20.5762 8.3379 20.9267 8.3379C21.2771 8.3379 21.6241 8.40698 21.9479 8.54117C22.2716 8.67537 22.5657 8.87206 22.8134 9.12C23.186 9.49306 23.4397 9.96822 23.5423 10.4854C23.645 11.0026 23.592 11.5386 23.3901 12.0257C23.1882 12.5128 22.8464 12.9291 22.4079 13.222C21.9694 13.5149 21.454 13.6712 20.9267 13.6712C20.3994 13.6712 19.8839 13.5149 19.4455 13.222C19.007 12.9291 18.6652 12.5128 18.4633 12.0257C18.2614 11.5386 18.2084 11.0026 18.311 10.4854C18.4137 9.96822 18.6674 9.49306 19.04 9.12ZM4.00002 28C6.46811 27.9296 8.83089 26.9845 10.6667 25.3333L6.66669 21.3333C4.00002 22.6667 4.00002 28 4.00002 28Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.991d56ce3056220a3cf71f9341ec7772.svg";
export { ForwardRef as ReactComponent };